import Busy from './Busy';
import CustomerSettingComponent from './CustomerSettingComponent';
import CustomerSettingsList from './CustomerSettingsList';
export default function CustomerSettingsComponent() {
    return (
        <>
            <Busy />
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                <div style={{ width: 350, paddingRight: 10 }}>
                    <CustomerSettingsList />
                </div>
                <div>
                    <CustomerSettingComponent />
                </div>
            </div>
        </>
    )
}